import React from 'react';
import './work-task.scss';
import 'devextreme/data/odata/store';

import { WorkTaskTable } from '../../components/library/work-task-table/WorkTaskTable';

export const WorkTasks = () => {
  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper view-wrapper-contact-list'>
        <WorkTaskTable isLoading={false} relationOid='' backTo='workTasksList' />
      </div>
    </div>
  );
};
